import request from '@/utils/request';

/**
 * 使用添加用户信息接口
 * @param data
 */
export function getHistoryDetail(historyId) {
  return request({
    url: `/api/historyDetail?historyId=${historyId}`,
    method: 'get',

  });
}

/**
 * 使用添加窗前光影表格查询接口
 * @param data
 */
export function getSunshineWindowList(historyId) {
  return request({
    url: `/api/sunshineHistoryWindow/sunshineWindowList?historyId=${historyId}`,
    method: 'get',

  });
}

/**
 * 使用添加窗前光影面积计算接口
 * @param data
 */
export function getDailyWindowSunShineArea(historyId, dateStr) {
  return request({
    url: `/api/sunshineHistoryWindow/historyWindowSunShineArea?historyId=${historyId}&dateStr=${dateStr}`,
    method: 'get',

  });
}